import React from "react";
import { useDispatch, useSelector, useStore as useReduxStore } from "react-redux";
import func from "@uikit/func";
import ContentFrame from "../../../../views/ContentFrame";
import SharesBuy from "../../../../views/components/SharesBuy";
import style from "./HtmlTemplate.module.css";
import StockLoading from "@views/components/StockLoading/StockLoading";

const HtmlTemplate: React.FC<any> = props => {
  const { displayType, textAreaValue, isResized, stockLoading } = props;

  const editorIdArr = useSelector((state: any) => state.fot.editorIdArr);
  const locusEditorId = useSelector((state: any) => state.fot.locusEditorId);

  return (
    <div className={`${style["white-frame"]} ${props.isTargetNode ? style["target"] : ""}`}>
      <StockLoading loading={stockLoading} />
      <div className={style["customJsFunc-box"]}>
        <div className={`${style["customJsFunc-content"]} ${style["custom-node"]} ${style[displayType]}`}>
          {textAreaValue.map((thought: any, idx: number) => {
            if (func.isEmpty(thought.results[0].type)) return null;
            return thought.results[0].type === "stock" ? (
              <div key={idx} style={{ height: "100%", overflow: "hidden" }}>
                {editorIdArr.some((x: any) => x.editorId === props.id && `canvas${x.editorId}` === locusEditorId) ? (
                  <SharesBuy filteredThoughts={[]} editorId={props.id} className={style["custom-node-sharebuy"]} />
                ) : (
                  <ContentFrame
                    className="custom-node"
                    id={idx}
                    locus="canvas"
                    zone="editorCustomNode"
                    content={thought}
                    editorId={props.id}
                    select_thought={() => {}}
                    add_angle={() => {}}
                    add_like={() => {}}
                    add_dislike={() => {}}
                    ContentRetrieval={() => {}}
                    enterQuery=""
                    otherModes={["studioMode", "editorMode"]}
                    handleImageLoaded={props.handleGroupStyle}
                  />
                )}
              </div>
            ) : (
              <ContentFrame
                className={`custom-node ${isResized ? "" : "default-resize"}`}
                key={idx}
                id={idx}
                locus="canvas"
                zone="editorCustomNode"
                content={thought}
                editorId={props.id}
                select_thought={() => {}}
                add_angle={() => {}}
                add_like={() => {}}
                add_dislike={() => {}}
                ContentRetrieval={() => {}}
                enterQuery=""
                otherModes={["studioMode", "editorMode"]}
                handleImageLoaded={props.handleGroupStyle}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default HtmlTemplate;
